import { render } from "./ModuleView.vue?vue&type=template&id=2c4c2d5e"
import script from "./ModuleView.vue?vue&type=script&lang=js"
export * from "./ModuleView.vue?vue&type=script&lang=js"

import "./ModuleView.vue?vue&type=style&index=0&id=2c4c2d5e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__